import {useState} from "react";
import * as api from "../../../services/api";
import {useFeedbackTools} from "../../../components/FeedbackTools";

const ruleCompare = (a, b) => (a.startDay > b.startDay) ? 1 : ((b.startDay > a.startDay) ? -1 : 0);

const useFilterRules = (defaultRule = null, initialTemporalRules = []) => {
    const [rule, setRule] = useState(defaultRule);
    const [temporalRules, setTemporalRules] = useState(initialTemporalRules.sort(ruleCompare));
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const addRule = async (rule) => {
        try {
            const createdRule = await api.FilterRules.createRule(rule);
            setRule(createdRule);
            showSuccessNotification("Hai creato un nuovo filtro");
        } catch (e) {
            showErrorNotification(e);
        }
    };

    const deleteRule = async (id) => {
        try {
            await api.FilterRules.deleteRule(id);
            setRule(null);
        } catch (e) {
            showErrorNotification(e);
        }
    };

    const addTemporalRule = async (rule) => {
        try {
            const createdRule = await api.FilterRules.createRule(rule);
            const newRules = temporalRules.concat([createdRule]).sort(ruleCompare);
            setTemporalRules(newRules);
            showSuccessNotification("Hai creato un nuovo filtro");
        } catch (e) {
            showErrorNotification(e);
        }
    };

    const deleteTemporalRule = async (id) => {
        try {
            await api.FilterRules.deleteRule(id);
            const newRules = temporalRules.filter(r => r.id !== id);
            setTemporalRules(newRules);
        } catch (e) {
            showErrorNotification(e);
        }
    };

    return {
        rule,
        temporalRules,
        addRule,
        addTemporalRule,
        deleteRule,
        deleteTemporalRule
    }
};

export {useFilterRules}